import { ImageShape } from '@enums';
import { getUserInitials } from '@utils';

export const generateInitialsAvatar = (
  fullName: string,
  shape: ImageShape,
  bgColor = '#f7f7f7',
  color = '#999999'
) => {
  const initials = getUserInitials(fullName);

  const canvas = document.createElement('canvas');
  const context1 = canvas.getContext('2d');
  const context2 = canvas.getContext('2d');

  const size = 96;
  const border = 2;
  canvas.width = size + border * 2;
  canvas.height = size + border * 2;

  if (shape === ImageShape.CIRCLE) {
    context2.beginPath();
    context2.arc(size / 2 + border, size / 2 + border, size / 2 + border, 0, 2 * Math.PI);
    context2.fillStyle = bgColor;
    context2.fill();
    context2.lineWidth = border;
    context2.strokeStyle = color;
    context2.stroke();
  } else if (shape === ImageShape.SQUARE) {
    context2.fillStyle = bgColor;
    context2.fillRect(0, 0, canvas.width, canvas.height);
    context2.strokeStyle = color;
    context2.strokeRect(border, border, size, size);
  }

  context1.beginPath();
  if (shape === ImageShape.CIRCLE) {
    context1.arc(size / 2 + border, size / 2 + border, size / 2, 0, 2 * Math.PI);
  } else if (shape === ImageShape.SQUARE) {
    context1.rect(border, border, size, size);
  }
  context1.lineWidth = border;
  context1.strokeStyle = color;
  context1.stroke();

  context2.fillStyle = color;
  context2.font = '35px IBMPlexSansRegular, Arial, serif';
  context2.textAlign = 'center';
  context2.textBaseline = 'middle';
  context2.fillText(initials, size / 2 + border, size / 2 + border + border);

  return canvas.toDataURL();
};
